import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";
import { request } from "../api";
import { url, port } from "../../../config/config";
import { useEffect } from "react";
import { headers } from "../../../config/config";

const { Bearer } = AUTHORIZATION;
const { get } = request;

// eslint-disable-next-line arrow-parens
const emailHealthCard = async (emailHealthCardQuery) => {
	try {
		// const payload = JSON.stringify(_payload);
		// console.log("payload", payload);

		const token = localStorage.getItem("@jwt_member");
		const endpoint = "member/health-card";
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `${Bearer} ${token}`
			},
			emailHealthCardQuery
		);
		if (response.status === 200) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const healthCard = {
	emailHealthCard
};
